import React from "react";

export default function DashboardStorageIcon()
{
      return (
            <svg
                  width={32}
                  height={32}
                  viewBox="0 0 32 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
            >
                  <path
                        d="M5.33335 26.6667H26.6667C28.1334 26.6667 29.3334 25.4667 29.3334 24C29.3334 22.5333 28.1334 21.3333 26.6667 21.3333H5.33335C3.86669 21.3333 2.66669 22.5333 2.66669 24C2.66669 25.4667 3.86669 26.6667 5.33335 26.6667ZM5.33335 22.6667H8.00002V25.3333H5.33335V22.6667ZM2.66669 7.99999C2.66669 9.46666 3.86669 10.6667 5.33335 10.6667H26.6667C28.1334 10.6667 29.3334 9.46666 29.3334 7.99999C29.3334 6.53333 28.1334 5.33333 26.6667 5.33333H5.33335C3.86669 5.33333 2.66669 6.53333 2.66669 7.99999ZM8.00002 9.33333H5.33335V6.66666H8.00002V9.33333ZM5.33335 18.6667H26.6667C28.1334 18.6667 29.3334 17.4667 29.3334 16C29.3334 14.5333 28.1334 13.3333 26.6667 13.3333H5.33335C3.86669 13.3333 2.66669 14.5333 2.66669 16C2.66669 17.4667 3.86669 18.6667 5.33335 18.6667ZM5.33335 14.6667H8.00002V17.3333H5.33335V14.6667Z"
                        fill="#4CC2FF"
                  />
            </svg>


      );
}
